<form [formGroup]="scanConfigurationForm">
  <div class="dashboard-tile">
    <div class="tile-header">
      <div *ngIf="_scanConfiguration?.id" class="tile-header-title">Update Scan Configuration <span class="text-primary">{{_scanConfiguration.name}}</span></div>
      <div *ngIf="!_scanConfiguration?.id" class="tile-header-title">New Scan Configuration</div>
    </div>
    <div class="tile-content">
      <div class="formFieldList">
        <mat-checkbox matTooltip="Is the scan configuration active and available for use?" formControlName="active">Active</mat-checkbox>
        <mat-form-field>
          <input matInput placeholder="Name" formControlName="name" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Definition Id" formControlName="definitionId" required>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="Type" formControlName="type" required>
            <mat-option *ngFor="let tp of availableScanConfigurationTypes | keyvalue" [value]="tp.value">{{tp.key}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="S3 Key (relative to vulnerability-scanner/content-definitions/ within the identify-assets bucket)" formControlName="s3Key" required>
          <mat-error *ngIf="scanConfigurationForm.controls.s3Key?.errors?.objectNotFound">The specified key does not exist within S3</mat-error>
        </mat-form-field>
        <div fxLayout="row wrap" fxLayoutGap="20px">
          <button [disabled]="scanConfigurationForm.invalid" mat-raised-button type="submit" color="primary" (click)="saveScanConfiguration()">Save</button>
          <button mat-raised-button type="button" color="primary" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</form>